/*
 * @Description: 
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2024-10-14 09:34:07
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout';

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: '/detail'
  },
  {
    path: "/album/:id",
    name: "Album",
    component: () => import(/* webpackChunkName: "Album" */ "@/views/Album.vue")
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: "detail" */ '../views/Detail.vue'),
    meta: {
      title: '画世界'
    }
  },
  {
    path: '/vote/:id?',
    name: 'VoteIndex',
    component: () => import(/* webpackChunkName: "VoteIndex" */ '../views/vote/index.vue'),
    meta: {
      keepAlive: true
    },
  },
  {
    path: '/votedetail/:id',
    name: 'VoteDetail',
    component: () => import(/* webpackChunkName: "VoteDetail" */ '../views/vote/detail.vue'),
    props: true,
    meta: {
      title: ''
    },
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "download" */ '../views/Download.vue'),
    meta: {
      title: '画世界'
    }
  },
  {
    path: '/pcdownload',
    name: 'PcDownload',
    component: () => import(/* webpackChunkName: "PcDownload" */ '../views/PcDownload.vue'),
    meta: {
      title: '画世界'
    }
  },
  {
    path: '/pandadownload',
    name: 'pandaDownload',
    component: () => import(/* webpackChunkName: "pandaDownload" */ '../views/Download.vue'),
    meta: {
      title: '画世界'
    }
  },
  {
    path: '/hsjprodownload',
    name: 'hsjProDownload',
    component: () => import(/* webpackChunkName: "hsjProDownload" */ '../views/HsjProDownload.vue'),
    meta: {
      title: '画世界Pro'
    }
  },
  {
    path: '/share',
    name: 'share',
    component: () => import(/* webpackChunkName: "share" */ '../views/Share.vue'),
    meta: {
      title: '画世界茶绘'
    }
  },
  {
    path: '/interview',
    name: 'interview',
    component: () => import(/* webpackChunkName: "interview" */ '../views/Interview.vue'),
    meta: {
      title: '大触零距离'
    }
  },
  {
    path: '/exp',
    name: 'exp',
    component: Layout,
    redirect: '/exp/wait',
    meta: {
      title: ' '
    },
    children: [
      {
        path: 'wait',
        name: 'expWait',
        component: () => import(/* webpackChunkName: "expWait" */ '../views/exp/start'),
        meta: {
          title: '\u200E'
        },
      },
      {
        path: 'queue',
        name: 'expQueue',
        component: () => import(/* webpackChunkName: "expQueue" */ '../views/exp/queue'),
        meta: {
          title: '\u200E'
        },
      }
    ]
  },
  {
    path: '/qualify',
    name: 'qualify',
    component: Layout,
    redirect: '/qualify/home',
    meta: {
      title: ' '
    },
    children: [
      {
        path: 'home',
        name: 'qualifyHome',
        component: () => import(/* webpackChunkName: "qualifyHome" */ '../views/marketQualify/Home.vue'),
        meta: {
          title: '集市入驻申请'
        },
      },
      {
        path: 'preorder',
        name: 'qualifyPreorder',
        component: () => import(/* webpackChunkName: "qualifyPreorder" */ '../views/marketQualify/Preorder.vue'),
        meta: {
          title: '集市入驻申请'
        },
      },
      {
        path: 'seller',
        name: 'qualifySeller',
        component: () => import(/* webpackChunkName: "qualifySeller" */ '../views/marketQualify/Seller.vue'),
        meta: {
          title: '集市入驻申请'
        },
      }
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "test" */ '../views/test.vue'),
    meta: {
      title: 'test'
    }
  },
  {
    path: '/hsjtransfer',
    name: 'transfer',
    component: Layout,
    redirect: '/hsjtransfer/index',
    meta: {
      title: ' '
    },
    children: [
      {
        path: 'index',
        name: 'transferIndex',
        component: () => import(/* webpackChunkName: "transferIndex" */ '../views/hsjTransfer/Index.vue'),
        meta: {
          title: '账户绑定'
        },
      },
      {
        path: 'login',
        name: 'transferLogin',
        component: () => import(/* webpackChunkName: "transferLogin" */ '../views/hsjTransfer/Login.vue'),
        meta: {
          title: '账户绑定'
        },
      },
      {
        path: 'binding',
        name: 'transferBinding',
        component: () => import(/* webpackChunkName: "transferBinding" */ '../views/hsjTransfer/Binding.vue'),
        meta: {
          title: '账户绑定'
        },
      },
      {
        path: 'info',
        name: 'transferInfo',
        component: () => import(/* webpackChunkName: "transferInfo" */ '../views/hsjTransfer/Info.vue'),
        meta: {
          title: '账户转移'
        }
      },
      {
        path: 'workinfo',
        name: 'transferWorkInfo',
        component: () => import(/* webpackChunkName: "transferWorkInfo" */ '../views/hsjTransfer/WorkInfo.vue'),
        meta: {
          title: '作品转移'
        }
      },
      {
        path: 'search',
        name: 'transferSearch',
        component: () => import(/* webpackChunkName: "transferSearch" */ '../views/hsjTransfer/Search.vue'),
        meta: {
          title: '账户转移'
        }
      },
      {
        path: 'searchlist',
        name: 'transferSearchList',
        component: () => import(/* webpackChunkName: "transferSearchList" */ '../views/hsjTransfer/SearchList.vue'),
        meta: {
          title: '账户转移'
        },
        props: true
      },
      {
        path: 'deal',
        name: 'transferDeal',
        component: () => import(/* webpackChunkName: "transferDeal" */ '../views/hsjTransfer/Deal.vue'),
        meta: {
          title: '账户转移'
        },
        props: true
      },
      {
        path: 'success',
        name: 'transferSuccess',
        component: () => import(/* webpackChunkName: "transferSuccess" */ '../views/hsjTransfer/Success.vue'),
        meta: {
          title: '账户转移'
        },
      },
      {
        path: 'error',
        name: 'transferError',
        component: () => import(/* webpackChunkName: "transferError" */ '../views/hsjTransfer/Error.vue'),
        meta: {
          title: '账户转移'
        },
        props: true
      },
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    component: Layout,
    redirect: '/activity/dreamworld',
    meta: {
      title: ' '
    },
    children: [
      {
        path: 'dreamworld',
        name: 'DreamWorld',
        component: () => import(/* webpackChunkName: "DreamWorld" */ '../views/activity/dream-world.vue'),
        meta: {
          title: '梦想世界-原创绘画大赛'
        },
      },
      {
        path: 'dreamworldvote',
        name: 'DreamWorldVote',
        component: () => import(/* webpackChunkName: "DreamWorld" */ '../views/activity/dream-world.vue'),
        meta: {
          title: '梦想世界-原创绘画大赛大众投票'
        },
      },
      {
        path: 'shuangcheng',
        name: 'Shuangcheng',
        component: () => import(/* webpackChunkName: "shuangcheng" */ '../views/activity/shuangcheng.vue'),
        meta: {
          title: '《镜 双城》动画Q版同人征集赛'
        },
      },
      {
        path: 'hsj4th',
        name: 'Hsj4th',
        component: () => import(/* webpackChunkName: "hsj4th" */ '../views/activity/hsj4th.vue'),
        meta: {
          title: '画世界四周年贺图征集'
        },
      },
      {
        path: '/activity/2023',
        name: 'activity2023',
        component: Layout,
        redirect: '/activity/2023/lanternfestival',
        meta: {
          title: ' '
        },
        children: [
          {
            path: "lanternfestival",
            name: "LanternFestival",
            component: () => import(/* webpackChunkName: "LanternFestival" */ "@/views/activity/year2023/LanternFestival.vue"),
            meta: {
              title: 'Parblo元宵节主题绘画大赛'
            }
          },
          {
            path: "parblodreamworld",
            name: "ParbloDreamWorld",
            component: () => import(/* webpackChunkName: "ParbloDreamWorld" */ "@/views/activity/year2023/parbloDreamWorld.vue"),
            meta: {
              title: '2023Parblo杯梦想世界绘画大赛'
            }
          },
          {
            path: "parbloprizedetail/:type",
            name: "ParbloPrizeDetail",
            component: () => import(/* webpackChunkName: "ParbloPrizeDetail" */ "@/views/activity/year2023/parbloPrizeDetail.vue"),
            meta: {
              title: 'Parblo 商品详情'
            }
          }
        ]
      },
      {
        path: 'cattea',
        name: 'CatTea',
        component: () => import(/* webpackChunkName: "cattea" */ '../views/activity/cattea.vue'),
        meta: {
          title: '《猫之茗》趣味创作挑战赛'
        },
      },
    ]
  },
  {
    path: '/activatevip',
    name: 'activatevip',
    component: Layout,
    redirect: '/activatevip/index',
    // component: () => import(/* webpackChunkName: "activatevip" */ '../views/ActivateVIP.vue'),
    meta: {
      title: '会员激活'
    },
    children:[
      {
        path: 'index',
        name: 'activatevipIndex',
        component: () => import(/* webpackChunkName: "activatevipIndex" */ '../views/activateVIP/index.vue'),
        meta: {
          title: '我的会员'
        },
      },
      {
        path: 'error',
        name: 'activatevipError',
        component: () => import(/* webpackChunkName: "activatevipError" */ '../views/activateVIP/error.vue'),
        meta: {
          title: '会员激活'
        },
        props: true
      },
    ]
  },
  {
    path: '/risktip',
    name: 'riskTip',
    props: true,
    component: () => import(/* webpackChunkName: "riskTip" */ '../views/RiskTip.vue'),
    meta: {
      title: '提示说明'
    }
  },
  {
    path: '/course',
    name: 'course',
    props: true,
    component: () => import(/* webpackChunkName: "course" */ '../views/course/Index.vue'),
    meta: {
      title: '课程投稿'
    }
  },
  {
    path: "/giftbag",
    name: "GiftBag",
    component: () => import(/* webpackChunkName: "GiftBag" */ "@/views/GiftBag.vue")
  },
  {
    path: "/paintingcompetition",
    name: "PaintingCompetition",
    component: () => import(/* webpackChunkName: "PaintingCompetition" */ "@/views/PaintingCompetition.vue")
  },
  {
    path: "/promotionpage",
    name: "PromotionPage",
    component: () => import(/* webpackChunkName: "PromotionPage" */ "@/views/PromotionPage.vue"),
    meta: {
      title: 'Parblo摸鱼小Q板专享优惠'
    }
  },
  {
    path: "/parblopage",
    name: "ParbloPage",
    component: () => import(/* webpackChunkName: "ParbloPage" */ "@/views/ParbloPage.vue"),
    meta: {
      title: 'Parblo小Q板新色上线！'
    }
  },
  {
    path: "/concaveandconvexworld",
    name: "ConcaveAndConvexWorld",
    component: () => import(/* webpackChunkName: "ConcaveAndConvexWorld" */ "@/views/ConcaveAndConvexWorld.vue"),
    meta: {
      title: '凹凸世界同人创作赛'
    }
  },
  {
    path: "/usercenter",
    name: "UserCenter",
    component: () => import(/* webpackChunkName: "UserCenter" */ "@/views/userCenter/index.vue"),
    meta: {
      title: '个人主页'
    }
  },
  {
    path: "/albumgroup",
    name: "AlbumGroup",
    component: () => import(/* webpackChunkName: "AlbumGroup" */ "@/views/albumGroup/index.vue"),
    meta: {
      title: '画集组'
    }
  },
  {
    path: "/drawidea",
    name: "DrawIdea",
    component: () => import(/* webpackChunkName: "DrawIdea" */ "@/views/drawIdea/index.vue"),
    meta: {
      title: '活动挑战'
    }
  },
  {
    path: "/activitychallenge/rejectionexplanation",
    name: "DrawIdeaRejectionExplanation",
    component: () => import(/* webpackChunkName: "DrawIdeaRejectionExplanation" */ "@/views/drawIdea/rejectionExplanation.vue"),
    meta: {
      title: '活动挑战常见驳回原因说明'
    }
  },
  {
    path: "/faction",
    name: "PaintTitle",
    component: () => import(/* webpackChunkName: "PaintTitle" */ "@/views/paintTitle/index.vue"),
    meta: {
      title: '画题详情'
    }
  },
  {
    path: '/hsjprocolorcard',
    name: 'hsjprocolorcard',
    component: Layout,
    // redirect: '/colorcard/shanhai',
    // component: () => import(/* webpackChunkName: "activatevip" */ '../views/ActivateVIP.vue'),
    meta: {
      title: '色卡'
    },
    children:[
      {
        path: 'shanhai',
        name: 'ShanHai',
        component: () => import(/* webpackChunkName: "ShanHaiColor" */ '../views/colorCard/shanhai.vue'),
        meta: {
          title: '天生会画·共绘山海色卡介绍'
        },
      }
    ]
  },
  {
    path: '/oppogiftbag',
    name: 'oppogiftbag',
    component: Layout,
    redirect: '/oppogiftbag/index',
    // component: () => import(/* webpackChunkName: "activatevip" */ '../views/ActivateVIP.vue'),
    meta: {
      title: '设备专享礼包'
    },
    children:[
      {
        path: 'index',
        name: 'OppoGiftBag',
        component: () => import(/* webpackChunkName: "OppoGiftBag" */ '../views/oppoGiftBag/index.vue'),
        meta: {
          title: '设备专享礼包'
        },
      },
      {
        path: 'brush',
        name: 'OppoBrushGiftBag',
        component: () => import(/* webpackChunkName: "OppoBrushGiftBag" */ '../views/oppoGiftBag/brush.vue'),
        meta: {
          title: '设备专享礼包'
        },
      },
    ]
  },
  {
    path: '/giftbag/:device/:type',
    name: 'GiftBagType',
    component: () => import(/* webpackChunkName: "GiftBagType" */ '../views/giftBag/common.vue'),
    meta: {
      title: '设备专享礼包'
    },
  },
  {
    path: '/course/:app/:courseId',
    name: 'Course',
    component: () => import(/* webpackChunkName: "CourseDetail" */ '../views/coursePage/courseDetail.vue'),
    meta: {
      title: '教程详情'
    },
    },
  {
    path: '/recruit',
    name: 'Recruit',
    component: Layout,
    meta: {
      title: '画世界招聘'
    },
    children:[
      {
        path: 'service',
        name: 'RecruitService',
        component: () => import(/* webpackChunkName: "RecruitService" */ '../views/recruitPages/service.vue'),
        meta: {
          title: '画世界招聘'
        },
      }
    ]
  },
  {
    path: '/fragmentedpages/:app/typicalproblem',
    name: 'TypicalProblem',
    component: () => import(/* webpackChunkName: "TypicalProblem" */ '../views/fragmentedPages/typicalProblem.vue'),
    meta: {
      title: '草稿加载失败原因和解决方法'
    },
  },
  {
    path: '/fragmentedpages/hsjpro/clouddraft',
    name: 'HsjproCloudDraft',
    component: () => import(/* webpackChunkName: "HsjproCloudDraft" */ '../views/fragmentedPages/hsjproCloudDraft.vue'),
    meta: {
      title: '画世界Pro云草稿'
    },
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "Notice" */ '../views/Notice.vue'),
    meta: {
      title: '通知'
    },
  },
  {
    path: '/fragmentedpages/2023/christmas/:app?',
    name: 'Christmas2023',
    component: () => import(/* webpackChunkName: "Christmas2023" */ '../views/fragmentedPages/2023/christmas.vue'),
    meta: {
      title: '圣诞大礼包'
    },
  },
  {
    path: "/download/note",
    name: "NoteDownload",
    component: () => import(/* webpackChunkName: "NoteDownload" */ "@/views/NoteDownload.vue")
  },
  {
    path: '/fragmentedpages/2024/springfestival/:app?',
    name: 'SpringFestival2024',
    component: () => import(/* webpackChunkName: "SpringFestival2024" */ '../views/fragmentedPages/2024/springFestival.vue'),
    meta: {
      title: '春节活动'
    },
  },
  {
    path: '/fragmentedpages/fairiesalbums/:app?',
    name: 'FairiesAlbums2024',
    component: () => import(/* webpackChunkName: "FairiesAlbums2024" */ '../views/fragmentedPages/2024/fairiesAlbums.vue'),
    meta: {
      title: '百妖谱x画世界'
    },
  },
  {
    path: '/parblo',
    name: 'Parblo',
    component: Layout,
    meta: {
      title: 'Parblo'
    },
    children:[
      {
        path: 'hsj/index',
        name: 'ParbloWifiHsj',
        component: () => import(/* webpackChunkName: "ParbloWifiHsj" */ '../views/parblo/hsj/index.vue'),
        meta: {
          title: 'Parblo摸鱼小Q板2代专享优惠'
        },
      },
      {
        path: 'hsjpro/index',
        name: 'ParbloWifiHsjPro',
        component: () => import(/* webpackChunkName: "ParbloWifiHsjPro" */ '../views/parblo/hsjpro/index.vue'),
        meta: {
          title: 'Parblo摸鱼小Q板2代专享优惠'
        },
      },
      {
        path: 'padpurple',
        name: 'ParbloPadPurple',
        component: () => import(/* webpackChunkName: "ParbloPadPurple" */ '../views/parblo/padPurple.vue'),
        meta: {
          title: 'Parblo小紫板二代'
        },
      },
      {
        path: 'padblue',
        name: 'ParbloPadBlue',
        component: () => import(/* webpackChunkName: "ParbloPadBlue" */ '../views/parblo/padBlue.vue'),
        meta: {
          title: '小蓝板'
        },
      },
      {
        path: 'padgreen',
        name: 'ParbloPadGreen',
        component: () => import(/* webpackChunkName: "ParbloPadGreen" */ '../views/parblo/padGreen.vue'),
        meta: {
          title: '小绿板'
        },
      },
      {
        path: '2024',
        redirect: '2024/dreamworld',
        component: Layout,
        meta: {
          title: ''
        },
        children: [
          {
            path: 'dreamworld/:app?',
            name: 'ParbloDreamWorld2024',
            component: () => import(/* webpackChunkName: "ParbloDreamWorld2024" */ '../views/parblo/2024/dreamWorld.vue'),
            meta: {
              title: '2024梦想世界'
            },
          }
        ]
      }
    ]
  },{
    path: '/hsjpro',
    name: 'HsjPro',
    component: Layout,
    meta: {
    },
    children:[
      {
        path: 'usageguide',
        name: 'HsjProUsageGuide',
        component: () => import(/* webpackChunkName: "HsjProUsageGuide" */ '../views/hsjPro/usageGuide/index.vue'),
        meta: {
          title: '画世界Pro使用指南'
        },
      }
    ]
  },
  {
    path: '/titlemanagementrule/:app?',
    name: 'TitleManagementRule',
    component: () => import(/* webpackChunkName: "TitleManagementRule" */ '../views/titleManagementRule.vue'),
    props: true,
    meta: {
      title: '画题题主/管理员申请及管理制度'
    },
  },
]

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

export default router
